import { Icon20LockOutline } from '@vkontakte/icons';
import { Button, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import emptystateImage from 'img/familyPreview/family-emptystate.png';
import emptystateImageDark from 'img/familyPreview/family-emptystate-dark.png';
import emptystateImageFree from 'img/familyPreview/family-emptystate-free.png';
import emptystateImageFreeDark from 'img/familyPreview/family-emptystate-free-dark.png';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { familyEmptyStateButtonText } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';

import styles from './FamilyEmptyStateNew.css';

interface FamilyEmptyStateNewProps {
    onFastCheckoutClick: () => void;
}

export const FamilyEmptyStateNew: React.FC<FamilyEmptyStateNewProps> = ({ onFastCheckoutClick }) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const [image, setImage] = useState(emptystateImage);
    useEffect(() => {
        if (isDarkTheme) {
            if (IS_PAID_USER) {
                setImage(emptystateImageDark);
            } else {
                setImage(emptystateImageFreeDark);
            }
        } else if (IS_PAID_USER) {
            setImage(emptystateImage);
        } else {
            setImage(emptystateImageFree);
        }
    }, [isDarkTheme, IS_PAID_USER]);

    return (
        <div
            className={classNames(styles.root, {
                [styles.freeRoot]: !IS_PAID_USER,
            })}
            data-qa-id="family-empty-state"
        >
            <div className={styles.content}>
                <div className={styles.textBlock}>
                    <Text weight="2" className={styles.title} data-qa-id="family-empty-state-title">
                        Здесь будут семейные папки{'\n'}и альбомы
                    </Text>
                    <Text size={16} className={styles.description} data-qa-id="family-empty-state-description">
                        Подключите семейную подписку Mail Space — и сохраняйте документы и фото в общем разделе <b>Семья</b>
                    </Text>
                </div>
                <Button
                    appearance="accent-invariable"
                    size="l"
                    className={styles.button}
                    onClick={onFastCheckoutClick}
                    data-qa-id="family-empty-state-button"
                >
                    {familyEmptyStateButtonText}
                </Button>
            </div>
            <div className={styles.icon} data-qa-id="family-empty-state-icon">
                <Icon20LockOutline />
            </div>
            <img src={image} alt="Раздел Семья" className={styles.image} data-qa-id="family-empty-state-image" />
        </div>
    );
};
